import { getServerUrl } from "./env";

export const API = {
  // 인증 관련
  auth: {
    TOKEN_LOGIN: `${getServerUrl()}/Player/LoginByToken`,
    LOGOUT: `${getServerUrl()}/Player/Logout`,
  },

  // 슬롯 게임 관련 API
  slot: {
    RESET: `${getServerUrl()}/v2/slot/reset`,
    BETTING_NTF: `${getServerUrl()}/v2/slot/bettingNtf`,
    SPIN: `${getServerUrl()}/v2/slot/spin`,
    GAME_CYCLE_FINISHED: `${getServerUrl()}/v2/slot/gamecycleFinished`,
    FAST_SPIN: `${getServerUrl()}/fastspin/spin`,
    FAST_SPIN_SKIP: `${getServerUrl()}/fastspin/skip`,
    FAST_SPIN_CURRENT: `${getServerUrl()}/fastspin/current`,
  },

  // 리플레이 관련 API
  replay: {
    BASE: `${getServerUrl()}/Replay`,
    SPIN: `${getServerUrl()}/Replay/spin`,
  },
} as const;
